export default [
  {
    text: 'Name',
    value: 'name',
    width: '260px',
    order: 0,
    sortable: true,
    hidable: false,
    hidden: false,
  },
  {
    text: 'Owner',
    value: 'owner.email',
    width: '240px',
    align: 'left',
    sortable: false,
    order: 2,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Active',
    value: 'isSuspended',
    align: 'left',
    sortable: true,
    order: 3,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Facilities Count/Limit',
    value: 'projectsCount',
    width: '200px',
    align: 'left',
    sortable: true,
    order: 3,
    hidable: true,
    hidden: false,
  },

  {
    text: 'Users Count/Limit',
    value: 'usersCount',
    width: '200px',
    align: 'left',
    sortable: true,
    order: 4,
    hidable: true,
    hidden: false,
  },
  // {
  //   text: 'Project Models/Limit',
  //   value: 'projectModels',
  //   width: '200px',
  //   align: 'left',
  //   sortable: true,
  //   order: 4,
  //   hidable: true,
  //   hidden: false,
  // },
  // {
  //   text: 'Scan Upload/Limit',
  //   value: 'scanUploads',
  //   width: '150px',
  //   align: 'left',
  //   sortable: true,
  //   order: 4,
  //   hidable: true,
  //   hidden: false,
  // },
  // {
  //   text: 'Scan Downloads/Limit',
  //   value: 'scanDownloads',
  //   width: '150px',
  //   align: 'left',
  //   sortable: true,
  //   order: 4,
  //   hidable: true,
  //   hidden: false,
  // },
  {
    text: 'Activity Levels',
    value: 'modules',
    width: '150px',
    align: 'left',
    sortable: true,
    order: 4,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Company Type',
    value: 'companyType',
    align: 'left',
    sortable: true,
    order: 5,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Region',
    value: 'region',
    align: 'left',
    sortable: false,
    order: 6,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Custom Domain',
    value: 'customDomainName',
    align: 'left',
    sortable: true,
    order: 7,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Custom Storage',
    value: 'hasCustomStorage',
    align: 'left',
    sortable: true,
    order: 8,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Created',
    value: 'createDate',
    order: 9,
    hidable: true,
    hidden: true,
  },
  {
    text: 'License Expiration Date',
    value: 'licenseExpiryDate',
    order: 10,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Actions',
    value: 'actions',
    align: 'right',
    sortable: false,
    order: 11,
    hidable: true,
    hidden: false,
    width: '92px',
  },
];
